import { Create, SimpleForm, TextInput, useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';

const jsonFormat = (value: unknown) => (value && typeof value === 'object' ? JSON.stringify(value, null, 2) : (value as string) ?? '');

const jsonParse = (value: string) => {
  try {
    return JSON.parse(value) as unknown;
  } catch {
    return value;
  }
};

const validateJson = (value: unknown): string | undefined => {
  if (!value) return 'Required';
  if (typeof value === 'object') return undefined;
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value) as unknown;
      if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return 'Must be a JSON object';
      return undefined;
    } catch {
      return 'Invalid JSON';
    }
  }
  return 'Must be a JSON object';
};

const BusinessRulesTemplatesCreate = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  return (
    <Create
      mutationOptions={{
        onSuccess: () => {
          notify('Created');
          navigate(-1);
        }
      }}
    >
      <SimpleForm>
        <TextInput source="country" label="Country code (e.g. mx, br)" required inputProps={{ maxLength: 10 }} helperText="Lowercase ISO-3166-alpha-2 (e.g. mx, br, us)" />
        <TextInput source="type" label="Rule type (e.g. payedOvertime, nightShift, tolerance)" required helperText="Must match the JSON key used in business_rules.rules" />
        <TextInput source="template" label="Template (JSON)" multiline fullWidth minRows={10} format={jsonFormat} parse={jsonParse} validate={validateJson} helperText="Valid JSON object representing the default rule template for this country" />
      </SimpleForm>
    </Create>
  );
};

export default BusinessRulesTemplatesCreate;
